import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { Select } from 'components/Form/subcomponents/Select';
import styled from 'styled-components';
import { colors, fonts, medias } from 'assets/styled/tokens';

import selectDropdown from 'assets/icons/select-dropdown-up.svg';
import { GridColumn, ModalGeneric } from 'components';

import { StyledModalGenericBody, StyledModalGenericClose } from 'components/ModalGeneric/styled';
export const TransparentBg = styled.div`
  background: rgba(0, 0, 0, 0.7);
  //opacity: 0.5;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  padding: 50px 0;
  z-index: 5;
  overflow-y: auto;
`;
export const NewChamadoContainer = styled.div`
  min-height: 293px;
  width: 336px;
  margin-top: auto;
  margin-bottom: auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 8px 0px #0000001a;
  @media (min-width: ${medias.desktopSm}) {
    width: 720px;
    min-height: 514px;
  }
`;
export const Header = styled.div`
  width: 100%;
  height: 56px;
  font-family: Blinker;
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: #f38a00;
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
`;
export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  //border-radius: 50%;
  border: 1px solid #e5e5e5;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    transform: scale(1.3);
    path {
      stroke: #bbbbbb;
      stroke-width: 2;
      fill: #bbbbbb;
    }
  }
`;
export const HeaderTitle = styled.h1`
  font-family: Blinker !important;
  font-size: 24px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: #f38a00;
  margin-left: 0;
  @media (min-width: ${medias.desktopSm}) {
    margin-left: 24px;
  }
`;
export const Content = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px 18px;
  display: flex;
  flex-direction: column;
  @media (min-width: ${medias.desktopSm}) {
    padding: 0px 36px;
  }
`;
export const QrCodeOptionButton = styled.button`
  width: 147px;
  height: 124px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 24px 12px;
  border: ${props => (props.selected ? '3px solid #F38A00' : '1px solid #dddddd')};
  background-color: ${props => (props.selected ? '#F5F3F1' : '#fff')};
  color: ${props => (props.selected ? '#F38A00' : '#888888')};
  border-radius: 12px;
  h2 {
    font-family: Blinker;
    font-weight: ${props => (props.selected ? '600' : '400')};
    line-height: 26px;
    text-align: center;
    font-size: 24px;
  }
  h5 {
    font-family: Blinker;
    font-weight: ${props => (props.selected ? '600' : '400')};
    line-height: 26px;
    text-align: center;
    font-size: 12px;
  }
  :first-child {
    margin-right: 24px;
  }
  @media (min-width: ${medias.desktopSm}) {
    width: 200px;
    height: 160px;
  }
`;

export const QrCodeButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 12px;
`;

export const StyledFormGroup = styled(FormGroup)`
  position: relative;
  label {
    font-size: 18px;
    margin-bottom: 20px;
    :first-of-type {
      margin-bottom: 10px;
    }
    @media (min-width: ${medias.desktopSm}) {
      font-size: 24px;
      margin-bottom: 24px !important;
    }
  }
`;
export const SubLabel = styled.label`
  display: none;
  @media (min-width: ${medias.desktopSm}) {
    display: block;
    position: absolute;
    top: 0;
    left: 272px;
    font-size: 16px !important;
    font-weight: 400px;
    color: #7f746a;
    line-height: 16px;
  }
`;
export const SubLabelMobile = styled.label`
  display: block;
  font-size: 16px !important;
  font-weight: 400px;
  color: #7f746a;
  line-height: 16px;
  margin-bottom: 20px !important;
  @media (min-width: ${medias.desktopSm}) {
    display: none;
  }
`;
export const StyledInnerFormGroup = styled(FormGroup)`
  width: ${props => props.width || 'auto'};
  label {
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 12px;
    width: ${props => props.width || 'auto'};
  }
  input {
    width: ${props => props.width || '234px'};
    height: 32px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    font-size: 16px;
    @media (min-width: ${medias.desktopSm}) {
      height: 48px;
    }
  }
`;
export const StyledInnerGridColumn = styled(GridColumn)`
  display: flex;
  margin-bottom: 0 !important;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  @media (min-width: ${medias.desktopSm}) {
    width: 720px;
    flex-direction: row;
    gap: 18px;
  }
`;
export const StyledSelect = styled(Select)`
  width: 100%;
  height: 32px;
  input {
    height: 32px;
    background: ${props =>
      props.isUnitSelected ? `url(${selectDropdown}) right 10px center no-repeat` : ''} !important;
  }
  @media (min-width: ${medias.desktopSm}) {
    //width: 569px;
    height: 48px;
    input {
      height: 48px;
    }
  }
  ul {
    background-color: #fff;
    max-height: 250px;
    div > div input {
      border: none;
      /* background: ${props => (props.isUnitSelected ? `url(${selectDropdown}) right 10px center no-repeat` : '')}
        url(${selectDropdown}) right 10px center no-repeat; */
      ::placeholder {
        padding-left: 24px;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.3px;
        font-weight: 400;
      }
    }
    div > div img {
      right: auto;
      left: 12px;
      height: 14px;
      width: 14px;
    }
    section {
      li {
        height: 32px;
        :hover {
          background-color: #f5f3f1;
          cursor: pointer;
        }
        input {
          height: 32px;
        }
        label {
          font-size: 12px;
          margin: 0;
          height: 32px;
        }
      }
    }
  }
`;
export const StyledFormRadio = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  font-family: ${fonts.family.text};
  font-size: 0.75rem;
  margin-bottom: 20px;
  @media (min-width: ${medias.desktopSm}) {
    flex-wrap: wrap;
    margin-bottom: 40px;
  }
  label {
    margin-left: 0.9375rem;

    &:first-child {
      margin-left: 0;
    }

    input {
      margin-right: 0.3125rem;
      cursor: pointer;
    }
  }
`;

export const AdvancedDetails = styled.button`
  min-width: 240px;
  height: 32px;
  border: 1px solid ${props => (props.hasSelection ? colors.primary : '#e5e5e5')};
  border-radius: 4px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  color: #888888;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  :hover {
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  }
  svg {
    height: 12px;
    width: 12px;
  }
  svg.first-icon {
    width: 16px;
    height: 16px;
  }
  @media (min-width: ${medias.desktopSm}) {
    height: 48px;
  }
`;
export const SaveButton = styled.button`
  width: 183px;
  height: 32px;
  border-radius: 4px;
  background-color: ${colors.primary};
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  @media (min-width: ${medias.desktopSm}) {
    height: 48px;
  }
`;
export const ErrorText = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #c25446;
  margin-bottom: 12px;
  margin-top: 10px;
`;

export const SuccessModal = styled(ModalGeneric)`
  h6 {
    color: ${props => (props.success ? colors.successGreen : '#EC6655')};
    margin-bottom: 18px;
  }
  p {
    color: ${colors.gray};
    text-align: center;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 19px;
  }

  ${StyledModalGenericClose} {
    margin-right: -8px;
  }
  ${StyledModalGenericBody} button {
    font-size: 14px;
    line-height: 16px;
    width: 96px;
  }
`;
